/* ============================================================
   Flexi Box Bundle — reusable "build your own bundle" script
   ------------------------------------------------------------
   Drop this file + the matching CSS + section liquid into any
   theme. Everything project-specific lives in FLEXI_BOX_CONFIG
   below — edit that, not the logic underneath it.
   ============================================================ */

const FLEXI_BOX_CONFIG = {
  // Extra top margin (px) added to the product-list wrapper so it
  // clears the sticky tab header. Set to null to skip entirely.
  // (null now — the tab bar is a normal in-flow bar, not fixed, so
  // no extra clearance is needed.)
  collectionListMarginTop: null,

  // Hide the theme's global announcement bar while this section is
  // mounted (only needed if it overlaps the sticky tab header).
  hideAnnouncementBar: false,

  // Remove the theme's default top margin on #SiteHeader (again,
  // only needed if the sticky tab header collides with it).
  removeSiteHeaderMargin: false,

  // Disable right-click / F12 devtools shortcut. Off by default —
  // this is a UX trade-off some clients want on gifting pages, but
  // it shouldn't ship on by default in a reusable base.
  disableRightClick: false,
  disableDevToolsShortcut: false,

  // Hide floating contact buttons (e.g. WhatsApp widgets) while on
  // specific pages. Add one entry per case; leave empty to skip.
  // Example:
  // [{ selector: '.WhatsAppButton__root', urlIncludes: ['products/my-bundle'] }]
  hideFloatingButtons: [],
};

document.addEventListener('DOMContentLoaded', function () {

  // ---------- Checkbox init ----------
  document.querySelectorAll("input[type='checkbox']").forEach(function (checkbox) {
    checkbox.disabled = false;
  });

  window.addEventListener('beforeunload', function () {
    window.scrollTo(0, 0);
  });

  // ---------- Keep the sticky tab bar directly under the site header ----------
  (function syncStickyTop() {
    const header = document.querySelector('[data-header-section]') || document.querySelector('.section-header');
    if (!header) return;
    const apply = function () {
      const h = header.offsetHeight || 60;
      document.documentElement.style.setProperty('--flexi-box-sticky-top', h + 'px');
    };
    apply();
    window.addEventListener('resize', apply);
    setTimeout(apply, 600);
  })();

  // ---------- Track cart-drawer open state ourselves ----------
  // (Not using the theme's own `.active`/`overflow-hidden` classes here —
  // those get re-applied by a delayed setTimeout chain in theme.js even
  // after the drawer has already been closed, which left our sticky bars
  // stuck hidden. This listens to the actual open/close clicks instead.)
(function trackCartDrawerOpenState() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  const sync = function () {
    document.body.classList.toggle('flexi-cart-open', drawer.classList.contains('active'));
  };
  new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  sync();
})();
  // ---------- Tabs ----------
  document.querySelectorAll('.tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.tab-content').forEach(function (content) {
        content.classList.remove('active-tab-content');
      });
      var dataId = tab.getAttribute('data-id');
      var targetContent = document.querySelector(".tab-content[data-id='" + dataId + "']");
      if (targetContent) targetContent.classList.add('active-tab-content');

      document.querySelectorAll('.tab').forEach(function (t) {
        t.classList.remove('active-tab');
      });
      tab.parentElement.querySelectorAll('.tab').forEach(function (t) {
        t.classList.add('active-tab');
      });

      updateAllBubbleCounters();

      var searchbar = document.getElementById('searchbar');
      if (searchbar) {
        searchbar.value = '';
        searchbar.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  });

  // ---------- Sticky header on scroll ----------
  let lastScrollTop = 0;
  window.addEventListener('scroll', function () {
    var height = window.innerHeight;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    document.querySelectorAll('.sticky-header').forEach(function (header) {
      if (scrollTop > height) header.classList.add('show');
      else header.classList.remove('show');

      if (scrollTop > lastScrollTop) header.classList.add('hide');
      else header.classList.remove('hide');
    });
    lastScrollTop = scrollTop;
  });

  // ---------- Bubble counters ----------
  function updateAllBubbleCounters() {
    document.querySelectorAll('.bubble-counter').forEach(function (counter) {
      var match = counter.id.match(/checkbox_count_tab_(\d+)/);
      if (!match) return;
      var tabId = match[1];
      var checkedCount = document.querySelectorAll('[data-id="tab' + tabId + '"] input[type="checkbox"]:checked').length;
      var selectionLimit = document.querySelector('.tab-content[data-id="tab' + tabId + '"]')?.getAttribute('data-product-limit');
      var isLimitReached = checkedCount >= (parseInt(selectionLimit, 10) || 0);
      var parentTab = counter.closest('.tab');
      var isActive = parentTab?.classList.contains('active-tab');

      counter.classList.remove('limit-reached', 'active-limit-reached');
      if (isLimitReached) {
        counter.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" class="check-icon" width="11" height="9" viewBox="0 0 11 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.66802 1.37429L4.48642 7.85309L0.416016 4.46069L1.18402 3.53909L4.31362 6.14669L8.73201 0.625488L9.66802 1.37429Z" fill="#fff" stroke="#fff" stroke-width="0.5"/></svg>';
        counter.classList.add(isActive ? 'active-limit-reached' : 'limit-reached');
      } else if (checkedCount > 0) {
        counter.textContent = checkedCount;
      } else {
        counter.textContent = '';
      }
    });
  }

   // ---------- Bottom progress bar (thumbnails + "x/y Added") ----------
  function updateFlexiProgressBar() {
    const track = document.getElementById('flexi-progress-thumbs');
    const countEl = document.getElementById('flexi-progress-count');
    const hintEl = document.getElementById('flexi-progress-hint');
    const submitBtn = document.getElementById('submit-btn');
    const stickyCart = document.querySelector('.sticky_cart');
    if (!track || !stickyCart) return;

    const total = (typeof totalproductSelection !== 'undefined' && totalproductSelection > 0)
      ? totalproductSelection
      : 0;

    const checked = Array.from(document.querySelectorAll('#flexi-box-form input[type="checkbox"]:checked'));
    const selectedCount = checked.length;
    const priceText = stickyCart.dataset.totalPrice || '';

    track.innerHTML = '';
    checked.forEach(function (cb) {
      const card = cb.closest('.product-info');
      const img = card ? card.querySelector('.flexi-img-primary img') : null;
      const thumb = document.createElement('div');
      thumb.className = 'flexi-thumb';
      if (img) {
        const im = document.createElement('img');
        im.src = img.currentSrc || img.src;
        im.alt = '';
        thumb.appendChild(im);
      }
      track.appendChild(thumb);
    });

    const remaining = Math.max(total - selectedCount, 0);
    for (let i = 0; i < remaining; i++) {
      const empty = document.createElement('div');
      empty.className = 'flexi-thumb flexi-thumb--empty';
      empty.textContent = '+';
      track.appendChild(empty);
    }

    if (countEl) countEl.textContent = selectedCount + '/' + total + ' Added';

    if (hintEl) {
      if (remaining > 0) {
        hintEl.style.display = '';
        hintEl.innerHTML = 'Add ' + remaining + ' More To Unlock <strong>' + priceText + '</strong>';
      } else {
        hintEl.style.display = 'none';
      }
    }

    if (submitBtn) {
      if (total > 0 && remaining === 0) {
        submitBtn.disabled = false;
        submitBtn.style.pointerEvents = 'auto';
        submitBtn.style.backgroundColor = '#0b0b0b';
      } else {
        submitBtn.disabled = true;
        submitBtn.style.pointerEvents = 'none';
        submitBtn.style.backgroundColor = '#ddd';
      }
    }
  }
  window.updateFlexiProgressBar = updateFlexiProgressBar;
  updateFlexiProgressBar();

  // ---------- Add-to-cart submit ----------
  (function attachBundleSubmit() {
    const submitBtn = document.getElementById('submit-btn');
    if (!submitBtn) return;
    if (submitBtn.dataset.bundleListenerAttached === '1') return;
    submitBtn.dataset.bundleListenerAttached = '1';

    submitBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      const btn = e.currentTarget;

      if (btn.dataset.running === '1') return;
      btn.dataset.running = '1';
      btn.disabled = true;
      btn.classList.add('loading');

      try {
        const form = document.getElementById('flexi-box-form');
        if (!form) throw new Error('flexi-box-form not found');

        form.querySelectorAll("input[type='checkbox']").forEach(function (cb) {
          cb.disabled = false;
        });

        const checkedInputs = Array.from(form.querySelectorAll('input[type="checkbox"]:checked'));
        if (checkedInputs.length === 0) {
          console.warn('[bundle] No items selected. Aborting add-to-cart.');
          return;
        }

        const variantId = parseInt(form.dataset.variantId, 10);
        const parentSku = String(form.dataset.sku || '');
        // dataset.price is in cents (e.g. 58899 = 588.99)
        const parentPriceCents = Math.round(Number(form.dataset.price) || 0);
        if (!parentPriceCents) {
          console.warn('[bundle] parent price missing or zero (dataset.price):', form.dataset.price);
        }

        const itemProperties = {};
        const bundleProperties = {};
        let itemCounter = 1;
        let bundleCounter = 1;

        bundleProperties['_bundle_product' + bundleCounter] = parentSku + '/0/1';
        bundleCounter++;

        const totalRegularCents = checkedInputs.reduce(function (sum, input) {
          return sum + Math.round(Number(input.dataset.price) || 0);
        }, 0);

        let priceAssignedCents = 0;
        checkedInputs.forEach(function (input, idx) {
          if (String(input.value).trim() === 'No') {
            input.disabled = true;
            return;
          }

          itemProperties['_ITEM' + itemCounter] = input.value;
          // Customer-facing line only — cart-drawer.liquid hides any
          // property starting with "_", so this is a separate, plain
          // property just so the cart shows what's actually in the box.
          // input.value is "Product Title - Size/SKU/VariantId" (set in
          // make-your-own-bundle-item.liquid), so splitting on '/' and
          // taking the first part gives "Product Title - Size".
          itemProperties['Item ' + itemCounter] = input.value.split('/')[0];

          // Per-item image + price so the cart can render each chosen
          // product as a mini line (thumbnail, name, price underneath).
          // Hidden ("_") props are read by snippets/bundle-cart-items.liquid.
          const card = input.closest('.product-info');
          const imgEl = card ? card.querySelector('.flexi-img-primary img') : null;
          let imgUrl = imgEl ? (imgEl.currentSrc || imgEl.src || '') : '';
          imgUrl = imgUrl.replace(/^http:/, 'https:');
          if (imgUrl) itemProperties['_img' + itemCounter] = imgUrl;
          // cents, e.g. 11500 = 115.00
          itemProperties['_price' + itemCounter] = String(Math.round(Number(input.dataset.price) || 0));

          let shareCents;
          const inputPriceCents = Math.round(Number(input.dataset.price) || 0);

          if (totalRegularCents > 0 && parentPriceCents > 0) {
            shareCents = Math.round((inputPriceCents / totalRegularCents) * parentPriceCents);
          } else if (parentPriceCents > 0) {
            const validCount = checkedInputs.filter(function (i) {
              return String(i.value).trim() !== 'No';
            }).length || 1;
            shareCents = Math.round(parentPriceCents / validCount);
          } else {
            shareCents = 0;
          }

          const isLastReal = (function () {
            const lastIdx = checkedInputs
              .map(function (i) { return String(i.value).trim() !== 'No'; })
              .lastIndexOf(true);
            return idx === lastIdx;
          })();

          if (isLastReal) shareCents = parentPriceCents - priceAssignedCents;

          priceAssignedCents += shareCents;

          const priceDecimal = (shareCents / 100).toFixed(2);
          const sku = input.dataset.sku || '';
          bundleProperties['_bundle_product' + bundleCounter] = sku + '/' + priceDecimal + '/1';

          itemCounter++;
          bundleCounter++;
        });

        const properties = Object.assign({}, itemProperties, bundleProperties);

        const cartDrawer = document.querySelector('cart-drawer');
        

        const payload = {
          items: [{ id: variantId, quantity: 1, properties: properties }]
        };

        // This theme's drawer re-renders from `response.sections`, so the
        // section ids must be requested as part of the add call.
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          try {
            payload.sections = cartDrawer
              .getSectionsToRender()
              .map(function (s) { return s.id; })
              .join(',');
            payload.sections_url = window.location.pathname;
          } catch (sectionErr) {
            console.warn('[bundle] could not resolve cart drawer sections:', sectionErr);
          }
        }

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        console.log('[bundle] add response:', data);

        // Shopify returns 4xx + { status, message, description } on failure.
        // Bail out BEFORE resetting — otherwise a failed add wipes every
        // selection and throws the user back to Step 1.
        if (!res.ok || data.status) {
          const msg = data.description || data.message || 'Could not add this box to the cart.';
          console.error('[bundle] add-to-cart failed:', msg, data);

          const bar = document.querySelector('.message-bar');
          const bodyP = bar ? bar.querySelector('.message-body p') : null;
          if (bar && bodyP) {
            const originalHTML = bodyP.innerHTML;
            bodyP.textContent = msg;
            bar.classList.remove('is-hidden');
            setTimeout(function () {
              bar.classList.add('is-hidden');
              bodyP.innerHTML = originalHTML;
            }, 4000);
          }
          return; // selections stay intact
        }

        // ---------- success ----------
        form.reset();
        form.querySelectorAll("input[type='checkbox']").forEach(function (cb) { cb.disabled = false; });
        document.querySelector(".tab[data-id='tab1']")?.click();

        btn.style.pointerEvents = 'none';
        btn.style.backgroundColor = '#ddd';

        if (typeof updateAllBubbleCounters === 'function') updateAllBubbleCounters();
        if (typeof updateFlexiProgressBar === 'function') updateFlexiProgressBar();
        // Refresh the header count + drawer exactly the way this theme's
        // own `product-form-context` element does.
        if (typeof publish === 'function') {
          publish('cart-update', {
            source: 'flexi-box-bundle',
            productVariantId: variantId,
            cartData: data
          });
        }

if (cartDrawer) {
  let drawerSections = data.sections;
  // Fallback: if the add response had no sections, fetch them now.
  if (!drawerSections) {
    try {
      const ids = cartDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      const secRes = await fetch(window.location.pathname + '?sections=' + ids);
      drawerSections = await secRes.json();
    } catch (secErr) {
      console.warn('[bundle] could not fetch cart drawer sections:', secErr);
    }
  }
  if (drawerSections) {
    if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
    cartDrawer.renderContents({ id: variantId, sections: drawerSections });

  } else {
    window.location = (window.routes && window.routes.cart_url) || '/cart';
  }
} else {
  window.location = (window.routes && window.routes.cart_url) || '/cart';
}

      } catch (err) {
        console.error('[bundle] submit error:', err);
      } finally {
        btn.classList.remove('loading');
        btn.disabled = false;
        btn.dataset.running = '0';
      }
    });
  })();

  // ---------- Checkbox selection logic ----------
  let checkboxes = document.querySelectorAll("#flexi-box-form input[type='checkbox']");

  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('click', function () {
      let currProductDataId = this.getAttribute('data-id-products');
      if (!currProductDataId) return;

      let currTabId = Number(currProductDataId.split('_')[1]);
      let tabContent = document.querySelector('.tab-content[data-id="tab' + currTabId + '"]');
      if (!tabContent) return;
      let selectionLimit = tabContent.getAttribute('data-product-limit');

      let productInfo = this.closest('.product-info');
      if (productInfo) {
        productInfo.querySelectorAll('.added_to_cart, .product_counter').forEach(function (el) {
          el.classList.add('_hidden');
        });
      }

      if (this.checked) {
        if (productInfo) {
          productInfo.querySelectorAll('.added_to_cart, .product_counter').forEach(function (el) {
            el.classList.remove('_hidden');
          });
        }
        let productTitle = this.value.split('/')[0];
        document.querySelectorAll('.message-bar').forEach(function (bar) {
          bar.classList.remove('is-hidden');
          let span = bar.querySelector('p span');
          if (span) span.textContent = productTitle;
          setTimeout(function () {
            bar.classList.add('is-hidden');
            if (span) span.textContent = '';
          }, 2500);
        });
      }

      let limit = parseInt(selectionLimit, 10) || 0;
      let n = document.querySelectorAll('[data-id=tab' + currTabId + '] input[type="checkbox"]:checked').length;
      let notChecked = document.querySelectorAll('[data-id=tab' + currTabId + '] input[type="checkbox"]:not(:checked)');
      let action = true;

      console.debug('[bundle] tab', currTabId, '— selected:', n, '/ required:', limit);

      if (limit > 0 && n >= limit) {
        notChecked.forEach(function (input) { input.disabled = true; });
      } else {
        action = false;
        notChecked.forEach(function (input) { input.disabled = false; });
      }

      updateAllBubbleCounters();
      updateFlexiProgressBar();
      if (action === true) {
        let nextTabElem = document.querySelector(".tab[data-id='tab" + (currTabId + 1) + "']");
        if (nextTabElem) nextTabElem.click();

        let searchbar = document.getElementById('searchbar');
        if (searchbar) {
          searchbar.value = '';
          searchbar.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }

      let totalChecked = document.querySelectorAll('#flexi-box-form input[type=checkbox]:checked').length;
      let submitBtn = document.getElementById('submit-btn');
      if (submitBtn) {
        submitBtn.style.display = 'inline-block';
        if (typeof totalproductSelection !== 'undefined' && totalChecked == totalproductSelection) {
          submitBtn.style.backgroundColor = '#0b0b0b';
          submitBtn.style.pointerEvents = 'auto';
          submitBtn.disabled = false;
        } else {
          submitBtn.style.backgroundColor = '#ddd';
          submitBtn.disabled = true;
        }
      }
    });
  });

  // ---------- Search bar ----------
  const searchbarEl = document.getElementById('searchbar');
  if (searchbarEl) {
    searchbarEl.addEventListener('keyup', function () {
      var value = this.value.toLowerCase();
      document.querySelectorAll('#collection-list li').forEach(function (li) {
        var link = li.querySelector('.product_flexi_title');
        li.style.display = (link && link.textContent.toLowerCase().includes(value)) ? '' : 'none';
      });
    });
  }
  document.querySelectorAll('.search-clear').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var searchbar = document.getElementById('searchbar');
      if (!searchbar) return;
      searchbar.value = '';
      searchbar.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
    });
  });

  // ============================================================
  // Everything below is optional, project-specific behaviour.
  // It's entirely driven by FLEXI_BOX_CONFIG at the top of this
  // file — nothing here runs unless a project turns it on.
  // ============================================================

  if (FLEXI_BOX_CONFIG.disableRightClick) {
    document.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  }

  if (FLEXI_BOX_CONFIG.disableDevToolsShortcut) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'F12' || e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
    });
  }

  if (Array.isArray(FLEXI_BOX_CONFIG.hideFloatingButtons) && FLEXI_BOX_CONFIG.hideFloatingButtons.length) {
    FLEXI_BOX_CONFIG.hideFloatingButtons.forEach(function (rule) {
      let attempts = 0;
      (function hideBtn() {
        const el = document.querySelector(rule.selector);
        const urlMatches = !rule.urlIncludes || rule.urlIncludes.some(function (part) {
          return window.location.href.includes(part);
        });
        if (el && el.style.display !== 'none' && urlMatches) {
          el.style.display = 'none';
        }
        if (attempts <= 7) {
          attempts++;
          setTimeout(hideBtn, 2000);
        }
      })();
    });
  }

  if (FLEXI_BOX_CONFIG.hideAnnouncementBar) {
    const announcementBar = document.querySelector('.announcement');
    if (announcementBar) announcementBar.style.display = 'none';
  }

  if (FLEXI_BOX_CONFIG.removeSiteHeaderMargin) {
    const siteHeader = document.getElementById('SiteHeader');
    if (siteHeader) {
      siteHeader.style.marginTop = '0px';
      siteHeader.classList.remove('site-header-margin-top');
    }
  }

  if (FLEXI_BOX_CONFIG.collectionListMarginTop != null) {
    const collectionListBundle = document.getElementById('collection-list');
    if (collectionListBundle) {
      collectionListBundle.style.marginTop = FLEXI_BOX_CONFIG.collectionListMarginTop + 'px';
    }
  }

});